import { FC, memo } from 'react';

import { InfoCardPlaceholder } from '@gem/components';
import { Skeleton } from '@gem/ui-kit';

import { useSyncAnimations } from '../hooks/useSyncAnimations';
import styles from './StickerPackPlaceholder.styles.m.css';

interface StickerPackPlaceholderProps {
  count?: number;
}
const ANIMATION_DURATION = 1000;

export const StickerPackPlaceholder: FC<StickerPackPlaceholderProps> = memo((props) => {
  const { count = 25 } = props;
  const { isFirstAnimated, isSecondAnimated } = useSyncAnimations({
    firstTimeout: 500,
    secondTimeout: ANIMATION_DURATION,
  });

  return (
    <>
      <div className={styles.header}>
        <InfoCardPlaceholder
          isSecondAnimated={isSecondAnimated}
          isFirstAnimated={isFirstAnimated}
        />
      </div>
      <div className={styles.container}>
        {Array.from({ length: count }, (_, key) => {
          return (
            <Skeleton
              isAnimated={isSecondAnimated}
              className={styles.sticker}
              height="85px"
              borderRadius="6px"
              animationConfig={{
                duration: ANIMATION_DURATION,
              }}
            />
          );
        })}
      </div>
      <div className={styles.footer}>
        <Skeleton
          isAnimated={isSecondAnimated}
          width="88px"
          height="40px"
          borderRadius="26px"
          animationConfig={{
            duration: ANIMATION_DURATION,
          }}
        />
      </div>
    </>
  );
});
